// Generic async result. Shape is compatible with useApiFetch's response.
export const toSuccess = (data = null) => ({ success: true, data, error: null });
export const toFailure = (error) => ({ success: false, data: null, error });

// Runs an async task and wraps its outcome in a Result, so callers don't repeat try/catch.
export const runAsResult = async (task) => {
    try {
        return toSuccess(await task());
    }
    catch (error) {
        return toFailure(error);
    }
};
